import About from "./components/About";
import Apprenticeship from "./components/Apprenticeship";
import Contact from "./components/Contact";
import EpreuveE4 from "./components/EpreuveE4";
import Home from "./components/Home";
import NavBar from "./components/NavBar";
import Portfolio from "./components/Portfolio";
import SocialLinks from "./components/SocialLinks";
import Technologies from "./components/Technologies";
import Veille from "./components/Veille";

function App() {
  return (
    <div>
      <NavBar />
      <Home />
      <About />
      <Portfolio />
      <Apprenticeship />
      <Technologies />
      {/* <EpreuveE4 /> */}
      {/* <Veille /> */}
      <Contact />

      <SocialLinks />
    </div>
  );
}

export default App;
